import {NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Injectable} from '@angular/core';
import dayjs from 'dayjs';
import {DEFAULT_DATE_FORMAT} from 'shared/magic';
import {TranslocoService} from '@ngneat/transloco';

@Injectable()
export class NgbDateCustomAdapter extends NgbDateAdapter<string> {

	fromModel(value: string | null): NgbDateStruct | null {
		if (!value || !dayjs(value).isValid()) return null;

		const date = dayjs(value);
		return {
			day : date.date(),
			month : date.month() + 1,
			year : date.year()
		};
	}

	toModel(date: NgbDateStruct | null): string | null {
		if (!date) return null;
		const { year, month, day} = date;
		return new Date(year, month - 1, day).toISOString();
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable({providedIn: 'root'})
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {

	constructor(private transloco: TranslocoService) {
		super();
	}

	parse(value: string | null): NgbDateStruct | null {
		if (!value || !dayjs(value).isValid()) return null;
		const date = dayjs(value);
		return {
			day : date.date(),
			month : date.month() + 1,
			year : date.year()
		};
	}

	format(date: NgbDateStruct | null): string | null {
		if (!date) return null;
		const { year, month, day} = date;
		const dateString = new Date(year, month - 1, day).toISOString();
		const defLang = this.transloco.getDefaultLang();
		return dayjs(dateString).locale(defLang).format(DEFAULT_DATE_FORMAT);
	}
}
